import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsRoleAssignmentApi } from '@/features/api/hooks/participant/useParticipantsRoleAssignmentApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetOwnGlobalRoleAssignments = () => {
  const { isAuthenticated } = useAuth();
  const api = useParticipantsRoleAssignmentApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.GLOBAL_ROLE_ASSIGNMENTS],
    queryFn: () => api.getOwnGlobalRoleAssignments(),
    enabled: isAuthenticated
  });
};
